import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BaseOrderDirectionEnum } from '../../../shared/enums/base-order-direction.enum';
import { BaseQueryParamService } from '../../../shared/services/base-query-param.service';

@Component({
  selector: 'base-sortable-headline-item',
  templateUrl: './base-sortable-headline-item.component.html',
})
export class BaseSortableHeadlineItemComponent implements OnInit, OnDestroy {
  @Input() label = '';
  @Input() orderKey = '';
  @Input() clientSide = false;

  @Output() sortChange = new EventEmitter<{
    key: string;
    direction: BaseOrderDirectionEnum | undefined;
  }>();

  orderDirection: BaseOrderDirectionEnum | undefined;
  directions = BaseOrderDirectionEnum;
  directionListOrder = [undefined, BaseOrderDirectionEnum.asc, BaseOrderDirectionEnum.desc];
  _activeKey: string;

  private destroy$ = new Subject();

  constructor(private queryParamsService: BaseQueryParamService, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.setInitialOrderDirection();

    this.activatedRoute.queryParams
      .pipe(
        takeUntil(this.destroy$),
        map((params) => params.order?.split(',') || [])
      )
      .subscribe(([key, _]) => {
        this._activeKey = key;
        if (this.orderKey !== key) {
          this.orderDirection = undefined;
        }
      });
  }

  setInitialOrderDirection(): void {
    const [currentKey, currentDirection] = (this.activatedRoute.snapshot.queryParams.order || '').split(',');
    if (this.orderKey === currentKey) {
      this.orderDirection = currentDirection;
    } else {
      this.orderDirection = undefined;
    }
  }

  onOrderChanged(): void {
    this.toggleOrderDirection();

    if (this.clientSide) {
      this.sortChange.emit({
        key: this.orderKey,
        direction: this.orderDirection,
      });

      this._activeKey = this.orderDirection ? this.orderKey : '';
    } else {
      this.updateQueryParams(() => {
        this.queryParamsService.filterSubject.next({ page: 1 });
      });
    }
  }

  toggleOrderDirection(): void {
    const nextIndex = (this.directionListOrder.indexOf(this.orderDirection) + 1) % this.directionListOrder.length;
    this.orderDirection = this.directionListOrder[nextIndex];
  }

  updateQueryParams(callback: () => void): void {
    if (this.orderDirection) {
      this.queryParamsService.addParameter('order', `${this.orderKey},${this.orderDirection}`, callback);
    } else {
      this.queryParamsService.removeParameter('order', callback);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
